/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Alpha_Starting_ToastInputs */



/**
* | output |
* | --- |
* | "Starting alpha video export... encoding subtitles." |
*
* @param {Video_Export_Alpha_Starting_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_alpha_starting_toast = /** @type {((inputs?: Video_Export_Alpha_Starting_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Alpha_Starting_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Demarrage de l'exportation video alpha... encodage des sous-titres.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Alpha-Videoexport wird gestartet... Untertitel werden codiert.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Avvio dell'esportazione del video alfa... codifica dei sottotitoli.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Начало экспорта альфа-канала видео... кодирование субтитров.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Iniciando exportación de video alfa... codificando subtítulos.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("开始导出 alpha 通道视频……正在编码字幕。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("アルファビデオのエクスポートを開始しています...字幕をエンコードしています。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अल्फा वीडियो का निर्यात शुरू हो रहा है... उपशीर्षकों की एन्कोडिंग हो रही है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Iniciando a exportação do vídeo alfa... codificando legendas.")
	return /** @type {LocalizedString} */ ("Starting alpha video export... encoding subtitles.")
});